class ContactSelect {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const selectEle = document.querySelectorAll('.js-select select');
    selectEle.forEach((item, key) => {
      item.addEventListener('change', (event) => {
        console.log(event);
        const selectVal = event.target.value;
        if (selectVal) {
          event.target.style.color = 'rgba(23,23,23,1)';
        } else {
          event.target.style.color = 'rgba(23, 23, 23, 0.4)';
        }
      })
    })
  }
}
